import { adminGridBtn } from "./locationToolsContentConstants";
import type { LocationToolsContentViewModel } from "./useLocationToolsContentModel";

export function LocationToolsByLocationSection({ vm }: { vm: LocationToolsContentViewModel }) {
  const {
    locOptions,
    selectedLocationId,
    setSelectedLocationId,
    setMode,
    selectedLoc,
    canDeleteLocation,
    deleteLocWorking,
    deleteSelectedLocation,
    canEdit,
    draft,
    setOverride,
    linkMetas,
  } = vm;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
        {locOptions.map((loc) => (
          <button
            key={loc.id}
            type="button"
            onClick={() => setSelectedLocationId(loc.id === selectedLocationId ? null : loc.id)}
            className={
              adminGridBtn +
              (selectedLocationId === loc.id ? " ring-2 ring-indigo-400 border-indigo-300 dark:border-indigo-600" : "")
            }
          >
            <div className="font-semibold text-gray-900 dark:text-gray-100 text-sm">{loc.name}</div>
            <div className="text-[10px] text-gray-500">Edit all tools for this lot</div>
          </button>
        ))}
        <button
          type="button"
          onClick={() => {
            if (
              !window.confirm(
                "You will leave the Location tools view and open the form to add a new company location. Unsaved link changes on this page are not saved until you click Save.\n\nContinue?"
              )
            )
              return;
            setMode("addLocation");
          }}
          className={
            adminGridBtn +
            " border-dashed border-amber-400 dark:border-amber-700 text-amber-900 dark:text-amber-200 justify-center items-center text-center"
          }
        >
          <span className="text-2xl leading-none">+</span>
          <span className="text-sm font-semibold">Add location</span>
        </button>
      </div>

      {selectedLoc ? (
        <div className="rounded-xl border border-gray-200 dark:border-gray-600 bg-gray-50/80 dark:bg-gray-950/40 p-4 space-y-3">
          <div className="flex flex-wrap items-start justify-between gap-2">
            <div className="font-medium text-gray-900 dark:text-gray-100">{selectedLoc.name}</div>
            {canDeleteLocation ? (
              <button
                type="button"
                disabled={deleteLocWorking}
                onClick={() => void deleteSelectedLocation()}
                className="text-sm text-red-600 dark:text-red-400 hover:underline disabled:opacity-50 shrink-0"
              >
                {deleteLocWorking ? "Deleting…" : "Delete location (admin)"}
              </button>
            ) : (
              <p className="text-[10px] text-gray-500 max-w-[14rem] text-right">
                Only org admins and owners (or platform) can delete locations.
              </p>
            )}
          </div>
          <p className="text-xs text-gray-500">Set URLs for this location only; leave blank to use the org default for each tool.</p>
          {linkMetas.map((m) => (
            <label key={m.id} className="block text-xs">
              <span className="font-medium text-gray-700 dark:text-gray-300">{m.label}</span>
              <input
                type="url"
                disabled={!canEdit}
                className="mt-1 w-full rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-900 px-3 py-2 text-sm disabled:opacity-60"
                value={draft.byId[m.id]?.perLocation?.[selectedLoc.id] ?? ""}
                onChange={(e) => setOverride(m.id, selectedLoc.id, e.target.value)}
                placeholder={draft.byId[m.id]?.baseUrl ? `default: ${draft.byId[m.id]?.baseUrl}` : "https://…"}
              />
            </label>
          ))}
        </div>
      ) : (
        <p className="text-sm text-gray-500">Select a location, or add one using the dashed tile.</p>
      )}
    </div>
  );
}
